const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitFs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "fullscreen_x5F_exit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#030104"
    },
    points: "24.586,27.414 29.172,32 32,29.172 27.414,24.586 32,20 20,20 20,32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#030104"
    },
    points: "0,12 12,12 12,0 7.414,4.586 2.875,0.043 0.047,2.871 4.586,7.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#030104"
    },
    points: "0,29.172 2.828,32 7.414,27.414 12,32 12,20 0,20 4.586,24.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#030104"
    },
    points: "20,12 32,12 27.414,7.414 31.961,2.871 29.133,0.043 24.586,4.586 20,0  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFs);
export default __webpack_public_path__ + "static/media/exitFS.70901e6809718b8813e5a6fb42ded92b.svg";
export { ForwardRef as ReactComponent };